module.exports = __webpack_public_path__ + "img/crown2.d1cef6e2.svg";